function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { noop } from "lodash-es";
import classNames from "classnames";
import { onSpace } from "../../helpers";
import { CheckBox as Checked, CheckBoxOutlineBlank as Unchecked, IndeterminateCheckBox as Indeterminate } from "../../icons";
const CheckboxIcon = ({
  onSelectAll,
  checked,
  disabled,
  onChange,
  ...props
}) => {
  let icon;
  if (checked === "mixed") {
    icon = /*#__PURE__*/React.createElement(Indeterminate, null);
  } else if (checked) {
    icon = /*#__PURE__*/React.createElement(Checked, null);
  } else {
    icon = /*#__PURE__*/React.createElement(Unchecked, null);
  }
  function onClick(event) {
    let status = false;
    if (checked === "mixed") {
      status = true;
      onSelectAll();
    } else {
      status = !checked;
    }
    if (onChange) {
      onChange(status, event);
    }
  }
  return /*#__PURE__*/React.createElement("span", _extends({
    tabIndex: disabled ? -1 : 0,
    role: "checkbox",
    "aria-checked": (checked ?? false).toString(),
    "aria-disabled": disabled
  }, !disabled && {
    onClick,
    onKeyPress: onSpace(onClick)
  }, props, {
    className: classNames("checkbox-icon", {
      unchecked: checked === false,
      disabled,
      [props.className]: props.className
    })
  }), icon, props.children);
};
CheckboxIcon.displayName = "CheckboxIcon";
CheckboxIcon.defaultProps = {
  className: "",
  checked: false,
  onSelectAll: noop,
  disabled: false,
  children: undefined,
  onChange: undefined
};
CheckboxIcon.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.oneOf([true, false, "mixed"]),
  onSelectAll: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  onChange: PropTypes.func
};
export default CheckboxIcon;
//# sourceMappingURL=CheckboxIcon.js.map